export enum Layout {
  APP = "app",
  BLANK = "blank",
  EMPTY = "empty",
}
